import React, { useEffect, useState } from "react";
import { api, fmtCNPJ, fmtDateTime, cstatVariant } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";

const Logs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tenants, setTenants] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/logs", { params: { limit: 200 } });
      setLogs(r.data.items);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const r = await api.get("/tenants");
        setTenants(r.data.items || r.data);
      } catch (e) {
        console.error("Erro ao carregar empresas", e);
      }
    };

    fetchTenants();
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="page-logs">
      <PageHeader
        title="Logs do Worker"
        subtitle="Histórico detalhado de sincronização. Veja o tempo de resposta, o status de cada consulta e a quantidade de documentos capturados em tempo real."
      />
      <div className="px-4 md:px-8 py-6">
        <div className="bg-white border border-border rounded-sm overflow-x-auto">
          <table className="data-table" data-testid="logs-table">
            <thead>
              <tr>
                <th className="whitespace-nowrap">Quando</th>
                <th className="whitespace-nowrap">Empresa / CNPJ</th>
                <th className="whitespace-nowrap">NSU Inicial → Final</th>
                <th>cStat</th>
                <th className="w-full">Motivo</th>
                <th className="text-right whitespace-nowrap">Docs</th>
                <th className="text-right whitespace-nowrap">Duração</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-8 text-muted-foreground"
                  >
                    Carregando...
                  </td>
                </tr>
              )}
              {!loading && logs.length === 0 && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center py-12 text-muted-foreground"
                  >
                    Nenhum log ainda.
                  </td>
                </tr>
              )}
              {logs.map((l) => (
                <tr key={l.id} data-testid={`log-row-${l.id}`}>
                  <td className="text-xs whitespace-nowrap">
                    {fmtDateTime(l.created_at)}
                  </td>
                  <td className="whitespace-nowrap">
                    <div className="text-sm font-medium">
                      {tenants?.find((t) => t.id === l.tenant_id)
                        ?.razao_social || "Sua Empresa"}
                    </div>
                    <div className="font-mono text-xs text-muted-foreground">
                      {fmtCNPJ(l.cnpj)}
                    </div>
                  </td>
                  <td className="font-mono text-xs whitespace-nowrap">
                    {l.nsu_inicial} → {l.nsu_final}
                  </td>
                  <td>
                    <StatusBadge variant={cstatVariant(l.cstat)}>
                      {l.cstat}
                    </StatusBadge>
                  </td>
                  <td className="text-xs min-w-[200px]">
                    {l.motivo || "—"}
                    {l.error && (
                      <div className="text-destructive mt-1">
                        {l.error.slice(0, 200)}
                      </div>
                    )}
                  </td>
                  <td className="text-right font-mono">{l.docs_recebidos}</td>
                  <td className="text-right font-mono text-xs whitespace-nowrap">
                    {l.duracao_ms} ms
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Logs;
